// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K4xCa","col":"styles_col__1-Uvz","actions":"styles_actions__1tWO-","conflict":"styles_conflict__2kAKJ"};